import { createAsyncThunk } from '@reduxjs/toolkit';
import { instance } from '../api/api';
import { ManagerType } from './types';

export const getManagers = createAsyncThunk(
  'managers/getManagers',
  async ({ token }: { token: string }, thunkAPI) => {
    try {
      const response = await instance.get<ManagerType[]>('client-managers', {
        headers: { authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Ошибка при получении менеджеров');
    }
  }
);

export const getCurrentManager = createAsyncThunk(
  'managers/getCurrentManager',
  async ({ id, token }: { id: number; token: string }, thunkAPI) => {
    try {
      const response = await instance.get<ManagerType>(`client-managers/${id}`, {
        headers: { authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Ошибка при получении менеджера');
    }
  }
);

export const createManager = createAsyncThunk(
  'managers/createManager',
  async ({ data, token }: { data: any; token: string }, thunkAPI) => {
    try {
      const response = await instance.post('client-managers', data, {
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || 'Ошибка при создании менеджера');
    }
  }
);

export const deleteManager = createAsyncThunk(
  'managers/deleteManager',
  async ({ id, token }: { id: number; token: string }, thunkAPI) => {
    try {
      const response = await instance.delete(`client-managers/${id}`, {
        headers: { authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Ошибка при удалении менеджера');
    }
  }
);

export const updateManager = createAsyncThunk(
  'managers/updateManager',
  async (
    {
      managerId,
      data,
      token,
    }: { managerId: number | string; data: Partial<ManagerType>; token: string },
    thunkAPI
  ) => {
    try {
      const response = await instance.patch<ManagerType>(
        `client-managers/${managerId}`,
        data,
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data || 'Ошибка при обновлении менеджера');
    }
  }
);
